import { DateTime } from 'luxon';
import { ReleaseIdCard } from 'front-office/view-models/release-id-card';
import { Document } from 'front-office/view-models/release-id-card/document';
import { RegistryOffice } from 'front-office/view-models/release-id-card/registry-office';
import { Residence } from 'front-office/view-models/release-id-card/residence';
import { AccordionProfessionTitle } from 'shell/view-models/accordion-profession-title';

export const initialValueDocument: Document = {
  municipality: undefined, // ente collegato
  releaseDate: DateTime.now(),
  type: 'C',
};

export const initialValueRegistryOffice: RegistryOffice = {};

export const initialValueResidence: Residence = {};

export const initialValueOtherData: AccordionProfessionTitle = {};

export const initialValues: ReleaseIdCard = {
  isDocument: true,
  document: initialValueDocument,
  registryOffice: initialValueRegistryOffice,
  residence: initialValueResidence,
  otherData: initialValueOtherData,
};
